import styled from 'styled-components';
import { MAX_WRAPPER_SIZE } from '../../../../settings';

export default {
    CreditContainer: styled.div.attrs({ className: 'credit-container' })`
        box-shadow: ${({ base }) => base ? 'none' : '0 5px 40px rgba(0, 0, 0, 0.1)'};
        max-width: ${MAX_WRAPPER_SIZE};
        margin: 0 8px 0px 8px;

        @media (min-width: 900px) {
            margin: 0 0 ${({ base }) => base ? 0 : 41}px 0;
        }
        
    `,
    DropdownMenu: styled.div.attrs({ className: 'dropdown-menu' })`
        max-height: 1px;
        overflow: hidden;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        transition: all .2s ease-in-out;
        box-sizing: border-box;
        padding: 0 16px;
        opacity: 0;

        &.full-height {
            padding: 26px 16px;
            max-height: 100vh;
            opacity: 1;
            transition: all .2s ease-in-out;
            @media (min-width: 1220px) {
                max-height: ${props => props.isLoadedFrame && props.isLoadedFrame === true ? 'auto' : '291px'};
            }
        }

        @media (min-width: 600px) {
            display: grid;
            grid-gap: 10px;
            grid-template-columns: repeat(1, 1fr);
        }
        @media (min-width: 1000px) {
            grid-template-columns: repeat(2, minmax(150px, 1fr));
        }
        ${({ base }) => !base && `
            @media (min-width: 1220px) {
                grid-template-columns: repeat(3, 1fr);
            }
        `}
    `,
    DropdownButton: styled.button.attrs({ className: 'mobile-header' })`
        width: 100%;
        height: 88px;
        position: relative;
        padding: 17px 17px;
        border: none;
        outline: none;
        border-bottom: ${props => props.isOpen ? '1px solid #E3E4E5' : 'none'};
        background: white;

        @media (min-width: 900px) {
            display: none;
        }
    `,
    MobileHeaderTitle: styled.div.attrs({ className: 'title' })`
        font-family: Toyota Display Bold,serif;
        font-size: 18px;
        text-align: left;
    `,
    MobileHeaderArrow: styled.img.attrs({ className: 'arrow' })`
        position: absolute;
        top: calc(50% - 3px);
        right: 51px;
        width: 11px;
        height: 7px;
        transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
        transition: transform 0.5s ease;
    `,
    UserMessageStyle: styled.div`
        margin: 25px auto;
        font-family: Noto Sans,sans-serif;
        font-size: 18px;
        line-height: 30px;
        color: #202020;
        text-align: left;
        width: 90%;
        padding: 15px;
        @media (min-width: 700px) {
            margin: 0;
            padding: 0;
            margin-bottom: 50px;
        }
    `,
};
